// ----------------------------------------------------------------------------
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// ----------------------------------------------------------------------------

/* eslint-disable @typescript-eslint/no-inferrable-types */

// Scope Base of AAD app. Use the below configuration to use all the permissions provided in the AAD app through Azure portal.
// Refer https://aka.ms/PowerBIPermissions for complete list of Power BI scopes

// URL used for initiating authorization request
export const authorityUrl: string = "https://login.microsoftonline.com/";

// End point URL for Power BI API
export const powerBiApiUrl: string = "https://api.powerbi.com/";

// Scope for securing access token
export const scopeBase: string[] = ["https://analysis.windows.net/powerbi/api/Report.Read.All"];

// Client Id (Application Id) of the AAD app.
export const clientId: string = "df546118-2928-456b-bdaa-da9c9f7abcf1";

// Id of the workspace where the report is hosted
export const workspaceId: string = "386a5e7d-704d-434c-a2e6-7c809402dac2";

// Id of the report to be embedded
export const reportId: string = "f263ae3e-1899-4465-b4f5-30e4e6002bca";

// Directory (tenant) ID of the AAD app
export const tenantId: string = "60b3a4ba-1185-430c-b69d-45183bf0a62f";